{
  "line.carriage.name": "Frachtkosten",
  "line.carriage.description": "Beförderung von {origin} nach {destination}, zugestellt am {delivered_on}.",
  "note.cash_on_delivery": "Bei der Zustellung eingezogene Nachnahme: {amount} {currency} (CMR-Feld 15). Dieser Betrag ist nicht Teil dieser Rechnung.",
  "document.proof_of_delivery": "Elektronischer Ablieferbeleg (ePOD)"
}
